import * as yup from 'yup'
import { parseDateString } from './foiSchema'

const payInPersonSchema = yup.object().shape({
  paymentDate: yup.date().transform(parseDateString).typeError('Payment Date must be valid').required('Payment Date is required'),
  paymentTime: yup.date().required('Payment Time is required'),
  note: yup.string()
})

export { payInPersonSchema }
